import '../styles/globals.css'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import * as gtag from '../lib/gtag'

import Layout from '/src/components/Layout'
import Navbar from '/src/components/Navbar.js'

function MyApp({ Component, pageProps }) {
  const router = useRouter()

  useEffect(() => {
    const handleRouteChange = (url) => {
      gtag.pageview(url)
    }
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  const isAdminRoute = router.pathname.startsWith('/admin');

  return (
    <>
      {isAdminRoute ? (
        <Component {...pageProps} />
      ) : (
        <Layout>
          <Navbar />
          <Component {...pageProps} />
        </Layout>
      )}
    </>
  )
}

export default MyApp
